export const DATA_NAMES = {
    elements: 'elements',
    types: 'types',
}



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/DataTypes/DataTypesConstants.js